import React, { Fragment } from "react";

class Tooltip extends React.Component {
  render() {
    return (
      <div className="custom-tooltip">
        <i className="material-icons custom-tooltip-arrow">arrow_drop_up</i>
        <p className={""}>{this.props.msg}</p>
      </div>
    );
  }
}
export default Tooltip;
